<template>
    <div v-if="message || expired || subscribed">
        <div v-if="message">
            <div v-if="type === 'alert'" role="alert" :class="['trialAlert d-flex justify-content-between', designer.bg, designer.color]">
                <p :class="['w-100 mb-0 p-3 text-center', designer.color]">
                    {{ message }}
                    <a v-if="allowUpgrade" :class="['text-decoration-underline ps-1', designer.link]" @click="openSubscription" role="button">
                        {{ trans('general.defaults.subscribe_now') }}
                    </a>
                </p>
                <h3 type="button" :class="['close px-3 py-2 mb-0', designer.color]" @click="dismissAlert">
                    <span aria-hidden="true">&times;</span>
                </h3>
            </div>
            <div v-else>
                <basic-button
                    class="btn-primary"
                    :text="trans('general.defaults.subscribe')"
                    @click="openSubscription"/>
            </div>
        </div>

        <modal v-model="showSubscriptionPlans" :size="getModalSize"
               :title="!subscribed ? trans('general.defaults.subscribe_now') : trans('general.subscription.success.title')"
               class="subscriptionPlans" cls="subscriptionModal" @close="closeSubscription">
            <iframe v-if="subscriptionFrameUrl && !subscribed" :src="subscriptionFrameUrl"></iframe>

            <div v-if="subscribed" class="text-center p-4">
                <h5>{{ trans('general.subscription.success.sub_title')}}</h5>
                <p v-html="trans('general.subscription.success.desc')"></p>
            </div>
        </modal>
    </div>
</template>

<script>
import { setCookie, getCookie } from '../../services/CookiesManager';
import {mapLangToLocale} from "../../services/LocaleServices";
import Modal from "../organisms/Modal.vue";
import {getSessionProfile} from "../../services/SessionService";
import axios from "axios";
import BasicButton from "../atoms/BasicButton.vue";

export default {
    name: "trial-alert",
    components: {
        Modal, BasicButton
    },
    props: {
        allowUpgrade: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'alert'
        },
        reloadOnActivate: {
            type: Boolean,
            default: false
        },
        expired: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            message: null,
            subscribed: false,
            designer: {
                bg: 'bg-lighter-blue',
                color: 'text-light-blue',
                link: 'text-yellow',
            },
            dismissDays: 14,
            urgentDays: 7,
            showSubscriptionPlans: false,
            subscriptionFrameUrl: null,
            lang: document.documentElement.lang,
            csrfToken: document.head.querySelector('meta[name="csrf-token"]').content,
        }
    },
    computed: {
        getModalSize() {
            return this.subscribed ? 'md' : 'xl';
        }
    },
    methods: {
        setCookie, getCookie,
        setCSRFToken() {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
        },
        checkSubscription() {
            this.setCSRFToken();
            axios.get(`/settings/expired/read`)
                .then((response) => {
                    let space = response.data.data.space;

                    if (space.trial_ends_at != null || space.deleted_at != null) {
                        getSessionProfile();
                        this.message = ' ';
                    }

                    if (space.trial_ends_at != null) {
                        const daysLeft = this.daysLeft(space.trial_ends_at);

                        if(daysLeft != null) {
                            let cookieAlert = this.getCookie('upgrade-alert');

                            if(daysLeft <= this.urgentDays) {
                                this.designer.bg = 'bg-light-red';
                                this.designer.color = 'text-dark';
                                this.designer.link = 'text-dark-red';
                                this.dismissDays = 1;
                            }

                            let trialDaysLeft = 'trial_days_left_teacher';
                            let trialExpired = 'trial_expired_teacher';

                            if(this.allowUpgrade) {
                                trialDaysLeft = 'trial_days_left';
                                trialExpired = 'trial_expired';
                            }

                            if(cookieAlert === null) {
                                if(daysLeft > 0) {
                                    this.message = trans(`general.${trialDaysLeft}`, {x: daysLeft})
                                } else {
                                    this.message = trans(`general.${trialExpired}`, {x: daysLeft})
                                }
                            } else {
                                this.message = trans(`general.${trialDaysLeft}`, {x: daysLeft})

                                if(daysLeft <= this.urgentDays + 1) {
                                    this.setCookie('upgrade-alert', true, this.dismissDays);
                                }
                            }
                        }
                    }

                    if(this.allowUpgrade && (space.deleted_at != null || space.trial_ends_at != null)) {
                        this.$emit('upgrade-btn', true);
                        this.generateFrameUrl(space);
                        window.addEventListener('message', this.handleSubscription);
                    }
                });
        },
        handleSubscription(event) {
            if (event.origin !== appConfig.landingUrl) {
                return;
            }

            const formData = {
                plan_price: JSON.stringify({
                    children: event.data.children,
                    price: event.data.currency + event.data.price,
                    type: event.data.type,
                    price_per_child: event.data.price_per_child === 1,
                }),
            }

            if(event.data?.status === 'subscribed') {
                this.setCSRFToken();
                axios.post('/settings/expired/reactivate', formData).then((response) => {
                    const space = response.data.data.space;

                    if(space.deleted_at === null && space.trial_ends_at === null) {
                        this.$notify({
                            type: 'success',
                            text: trans('general.subscribe.success'),
                        });

                        this.subscribed = true;
                        this.message = null;

                        setTimeout(() => {
                            //this.showSubscriptionPlans = false;

                            if(this.reloadOnActivate) {
                                window.location.reload();
                            }
                        }, 10000);
                    } else {
                        this.$notify({
                            type: 'error',
                            text: trans('general.subscribe.failed'),
                        });
                    }
                });
            }
        },
        daysLeft(dateString) {
            const targetDate = new Date(dateString);
            const currentDate = new Date();
            const timeDifference = targetDate.getTime() - currentDate.getTime();
            return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
        },
        dismissAlert() {
            this.message = null;
            this.setCookie('upgrade-alert', true, this.dismissDays);
        },
        async generateFrameUrl(space) {
            const user = await getSessionProfile();

            let url = `${appConfig.landingUrl}/${mapLangToLocale(this.lang)}/pricing`;
            let queryParams = new URLSearchParams({
                app: 'true',
                name: user.name + ' ' + (user.surname ?? ''),
                center: space.name,
                centerId: space.id,
                country: space.country ?? '',
                address: space.address ?? user.address,
                phone: space.phone ?? user.phone,
                email: user.email ?? space.email,
            });

            this.subscriptionFrameUrl = `${url}?${queryParams.toString()}`;
        },
        openSubscription() {
            this.showSubscriptionPlans = true;
            document.body.style.overflow = 'hidden';
        },
        closeSubscription() {
            document.body.style.overflow = 'auto';
        },
    },
    mounted() {
        this.checkSubscription();
    }
}
</script>

<style>
.trialAlert {
    z-index: 10;
}

.subscriptionPlans iframe {
    width: 100%;
    height: calc(100vh - 200px);
    max-height: 750px;
    border-radius: 3px;
}

.subscriptionModal .modal-content {
    padding-left: 0;
    padding-right: 0;
}
</style>
